import { FormattedMessage as FM } from "react-intl";
import { Link } from "react-router";

function CardMainMenu({ _, item }) {
  const _key = `item-${item.name}-${_}`;
  return (
    <Link to={`/dash/${item?.link}`} key={_key}>
      <div
        className="flex flex-col justify-between bg-[#ededf7FF] shadow-md md:rounded-2xl rounded-md w-90 md:w-full my-9" overflow-hidden active:scale-95 transition duration-300 ease-in-out group
        style={{ backgroundColor: item.bg }}
      >
        <div className="flex flex-col space-y-[10px]">
          {item.Icon}
          <h3 className="text[30px] font-bold text-neutral-800 text-center">
            <FM id={item.name} />
          </h3>
          <p className="text-[#737b86FF] text-[14px] font-normal pb-1 text-center mx-4">
            <FM id={item.desc} />
          </p>
          <div
            className="flex w-full -md bg-gradient-to-r items-center text-center cursor-pointer
              disabled:!cursor-not-allowed justify-center gap-2 rounded-xs !h-[38px] amber border bg-[#FFCC00] hover:bg-[#EEEEF9] disabled:bg-[#FFF4CC] !text-[16px]
              shadow-[#37425433] shadow-xs !border-none py-[15px] md:rounded-sm text-sm lg:text-base "
          >
            <FM id="button_start" />
          </div>
        </div>
      </div>
    </Link>
  );
}

export default CardMainMenu;
